export const DISABLE_LOADER = "Disable-Loader";